import React from "react";
import { Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, LinearProgress } from "@mui/material";
import dayjs from "dayjs";

const DemographicsDialog = ({ demographicsModalOpen, setDemographicsModalOpen, selectedDemographicsDate, setSelectedDemographicsDate, getDemographicsForDate }) => (
<>
      {/* Demographics Modal */}
      <Dialog
        open={demographicsModalOpen}
        onClose={() => {
          setDemographicsModalOpen(false);
          setSelectedDemographicsDate(null);
        }}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, borderBottom: "1px solid #eee" }}>
          Registrations for {selectedDemographicsDate ? dayjs(selectedDemographicsDate).format("MMMM D, YYYY") : ""}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {selectedDemographicsDate && (() => {
            const stats = getDemographicsForDate(selectedDemographicsDate);
            return (
              <Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#142C5C",
                    marginBottom: "20px",
                    textAlign: "center",
                  }}
                >
                  {stats.total} new user{stats.total !== 1 ? "s" : ""} registered
                </Typography>

                {/* Gender Distribution */}
                <Box sx={{ marginBottom: "24px" }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "12px",
                      color: "#333",
                    }}
                  >
                    Gender Distribution
                  </Typography>
                  {Object.entries(stats.genderCounts).map(([gender, count]) => {
                    if (count === 0) return null;
                    const percentage = stats.total > 0 
                      ? ((count / stats.total) * 100).toFixed(1) 
                      : 0;
                    const maxCount = Math.max(...Object.values(stats.genderCounts));
                    const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0;
                    return (
                      <Box key={gender} sx={{ marginBottom: "10px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              textTransform: "capitalize",
                              color: "#555",
                            }}
                          >
                            {gender}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "#777",
                            }}
                          >
                            {count} ({percentage}%)
                          </Typography>
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value={barWidth}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                              borderRadius: 5,
                              backgroundColor: gender === "male" ? "#2196F3" : gender === "female" ? "#E91E63" : gender === "other" ? "#9C27B0" : "#9e9e9e",
                            },
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>

                {/* Age Distribution */}
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "12px",
                      color: "#333",
                    }}
                  >
                    Age Distribution
                  </Typography>
                  {Object.entries(stats.ageCounts).map(([bracket, count]) => {
                    if (count === 0) return null;
                    const percentage = stats.total > 0 
                      ? ((count / stats.total) * 100).toFixed(1) 
                      : 0;
                    const maxCount = Math.max(...Object.values(stats.ageCounts));
                    const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0;
                    return (
                      <Box key={bracket} sx={{ marginBottom: "10px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "#555",
                            }}
                          >
                            {bracket}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "#777",
                            }}
                          >
                            {count} ({percentage}%)
                          </Typography>
                        </Box>
                        <LinearProgress
                          variant="determinate"
                          value={barWidth}
                          sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: "#e0e0e0",
                            "& .MuiLinearProgress-bar": {
                              borderRadius: 5,
                              backgroundColor: "#142C5C",
                            },
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: "1px solid #eee" }}>
          <Button
            onClick={() => {
              setDemographicsModalOpen(false);
              setSelectedDemographicsDate(null);
            }}
            variant="contained"
            sx={{
              backgroundColor: "#142C5C",
              "&:hover": { backgroundColor: "#0f2247" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
</>
);

export default DemographicsDialog;
